import * as Sentry from "@sentry/react";

import type { ErrorPolicyOutcome } from "../errorPolicy";

export interface ReportFromErrorPolicyParams {
  error: unknown;
  errorMessage: string;
  policy: ErrorPolicyOutcome;
  mergedContext: Record<string, unknown>;
}

/**
 * Records saga failure in Sentry according to {@link resolveErrorPolicy} outcome.
 * Synchronous; does not dispatch Redux or show toasts.
 */
export function reportFromErrorPolicy({
  error,
  errorMessage,
  policy,
  mergedContext,
}: ReportFromErrorPolicyParams): void {
  if (policy.sentryEvent === "none") {
    return;
  }

  Sentry.withScope((scope) => {
    scope.setLevel(policy.severity);
    scope.setContext("saga_error", mergedContext);

    if (policy.sentryEvent === "message") {
      Sentry.captureMessage(errorMessage, policy.severity);
    } else {
      Sentry.captureException(error);
    }
  });
}
